import React, {
    Component
} from 'react'
import { makeStyles } from '@material-ui/core/styles';

import CircularProgress from '@material-ui/core/CircularProgress';
import ButtonBase from '@material-ui/core/ButtonBase';

const useStyles = makeStyles(theme => ({
  buttonProgress: {
    color: 'white',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

export default function ButtonProgress(props) {
    const classes = useStyles();

    return (
        <div className="button-wrapper">
            <ButtonBase type={props.type} className={props.className} onClick={props.onClick}>
                {!props.spinning && props.children}
            </ButtonBase>
            {props.spinning && <CircularProgress size={24} className={classes.buttonProgress}/>}
        </div>
    )
}